import { render, staticRenderFns } from "./FolderMenu.vue?vue&type=template&id=64d6d030&scoped=true&"
import script from "./FolderMenu.vue?vue&type=script&lang=js&"
export * from "./FolderMenu.vue?vue&type=script&lang=js&"
import style0 from "./FolderMenu.vue?vue&type=style&index=0&id=64d6d030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6d030",
  null
  
)

component.options.__file = "FolderMenu.vue"
export default component.exports